import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-logout-popup',
    templateUrl: './logout-popup.component.html',
    styleUrls: ['./logout-popup.component.scss'],
    standalone: false
})
export class LogoutPopupComponent implements OnInit {

  constructor(public modalController: ModalController) { }

  ngOnInit() {}

  dismiss(proceedLogout) {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'proceedLogout': proceedLogout
    });
  }

  closeModal() {
    this.dismiss(false)
  }

  proceedToLogout() {
    this.dismiss(true)
  }

}
